import setupOfflineMac from '../../assets/images/setupOffline_mac.png'
import setupOfflineMac2x from '../../assets/images/setupOffline_mac@2x.png'

interface SetupOfflineMacIconProps {
  className?: string
  alt?: string
}

/**
 * Setup Offline Mac Icon
 * Zeigt die Mac-Computer-Grafik für den Offline-Modus
 */
export const SetupOfflineMacIcon = ({
  className = '',
  alt = 'Offline Setup Mac'
}: SetupOfflineMacIconProps) => {
  return (
    <img
      src={setupOfflineMac}
      srcSet={`${setupOfflineMac2x} 2x`}
      alt={alt}
      className={className}
    />
  )
}
